import BaseNormalizer from "./BaseNormalizer";

const orderGroupsNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "merchantRegion",
  "createdAt",
  "updatedAt",
  "startup.name",
  "startup.edekaSupplierId",
  "startup.deletedAt",
  "orders.referenceCode",
  "orders.createdAt",
  "orders.netSumCents",
  "orders.netSumWithDepositSumCents",
  "orders.vatSumsCents",
  "orders.vatSums",
  "orders.depositSums",
  "orders.deliveryCostCents",
  "orders.grossSumCents",
  "orders.grossSumWithDeliveryCostCents",
  "orders.grossSumIncludingDepositCents",
  "orders.merchantStoreName",
  "orders.shippingAddress",
  "orders.billingAddress",
  "orders.note",
  "orders.state",
  "orders.createdAt",
  "orders.orderItems.id",
  "orders.orderItems.amount",
  "orders.orderItems.depositValueCents",
  "orders.orderItems.name",
  "orders.orderItems.netPriceCents",
  "orders.orderItems.vat",
  "orders.orderItems.orderUnit.id",
  "orders.orderItems.orderUnit.name",
  "orders.orderItems.orderUnit.ean",
  "orders.orderItems.orderUnit.supplierArticleNumber",
  "orders.orderItems.orderUnit.orderUnitType",
  "orders.orderItems.orderUnit.sumProductCount",
  "orders.orderItems.orderUnit.products.id",
  "orders.orderItems.orderUnit.products.productVariantName",
  "orders.discountsInKind.count",
  "orders.discountsInKind.orderUnit.name",
  "orders.discountsInKind.orderUnit.ean",
  "orders.discountsInKind.orderUnit.sumProductCount",
  "orders.discountsInKind.orderUnit.orderUnitType",
]);

export default orderGroupsNormalizer;
